import {
  Component,
  EventEmitter,
  Input, // Keep Input if you also want to use it as a regular component
  Output,
  OnChanges,
  SimpleChanges,
  inject,
  OnInit, // Import OnInit
  Optional, // Import Optional
  Inject // Import Inject
} from "@angular/core";
import { MAT_DIALOG_DATA } from '@angular/material/dialog'; // Import MAT_DIALOG_DATA
import { ColumnState, GridApi, GridReadyEvent } from "ag-grid-community";
import { DataService } from "src/app/data.service";

// Define an interface for the data you expect in the dialog
export interface AgTableDialogData {
  tableData?: {}[];
  colDefs?: {}[];
  tableClass?: string;
  tableHeight?: string;
  defaultSortModel?: ColumnState[];
  filterVal?: string;
  // Add any other inputs you want to pass
}

@Component({
  selector: "ag-table",
  templateUrl: "./ag-table.component.html",
  styleUrl: "./ag-table.component.css",
})
export class AgTableComponent implements OnChanges, OnInit {
  _dataService = inject(DataService);
  @Input() tableData?: {}[] = [];
  @Input() colDefs?: {}[] = [
      { headerName: "Tərəf-Müqabil", field: "customerName", flex: 2 },
      {
        headerName: "Alınan, ₼",
        field: "income",
        flex: 2,
      },
      {
        headerName: "Ödənən, ₼",
        field: "outgoings",
        flex: 2,
      },
      {
        headerName: "Tarix",
        field: "date",
        flex: 1,
        minWidth: 120,
        sortable: true,
      },
      {
        headerName: "Məlumat",
        field: "details",
        flex: 1,
        minWidth: 100,
        cellClass: (params) => {
          return "justify-content-start clipText";
        },
      },
    ];
  @Input() tableClass?: string = "";
  @Input() tableHeight?: string = "200px";
  @Input() defaultSortModel?: ColumnState[] = [{ colId: "date", sort: "desc", sortIndex: 0 }];
  @Input() filterVal? = "";

  @Output() rowClicked = new EventEmitter<any>();
  protected gridApi!: GridApi;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public dialogData?: AgTableDialogData) {}

  ngOnInit(): void {
    if (this.dialogData) {
      this.tableData = this.dialogData.tableData || this.tableData;
      this.colDefs = this.dialogData.colDefs || this.colDefs;
      this.tableClass = this.dialogData.tableClass || this.tableClass;
      this.tableHeight = this.dialogData.tableHeight || this.tableHeight;
      this.defaultSortModel = this.dialogData.defaultSortModel || this.defaultSortModel;
      this.filterVal = this.dialogData.filterVal || this.filterVal;
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridApi.setGridOption("includeHiddenColumnsInQuickFilter", true);
    if (this.defaultSortModel) {
      params.api.applyColumnState({ state: this.defaultSortModel });
    }
    // Apply initial filter if grid is ready and filterVal is set
    if (this.filterVal) {
      this.gridApi.setGridOption("quickFilterText", this.filterVal);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.gridApi && changes?.filterVal) {
      this.gridApi.setGridOption(
        "quickFilterText",
        changes.filterVal.currentValue
      );
    }
  }

  // Helper to handle row clicks and emit them
  onRowClicked(event: any) {
    this.rowClicked.emit(event);
  }
}